import Vue from 'vue'
import Toasted from 'vue-toasted'

// variable used because Toasted "singleton" works only globally, not on a type of toast..
let toastLogInCount = 0

Vue.use(Toasted, {
  globalToasts: {
    // have your toast name as propery name
    // it should accept 2 parameters 'payload' and 'initiate' callback
    // NOTE : you should return the initiate callback
    success: function (message, initiate) {
      // initiate(Message/html, option/string)
      // error/show/success/info you can pass main function names or an option object
      return initiate(message, {
        type: 'success',
        duration: 3000,
        position: 'top-right',
        theme: 'toasted-primary'
      })
    },
    error: function (message, initiate) {
      return initiate(message, {
        type: 'error',
        duration: 3000,
        position: 'bottom-right',
        theme: 'toasted-primary'
      })
    },
    logIn: function (payload, initiate) {
      if (toastLogInCount <= 0) {
        toastLogInCount++
        return initiate(payload.message, {
          type: 'warn',
          position: 'top-center',
          theme: 'toasted-primary',
          action: {
            text: payload.actionText,
            onClick: async (e, toastObject) => {
              toastObject.goAway(0)
              payload.onClick(e)
            }
          },
          onComplete: () => {
            toastLogInCount--
          }
        })
      }
    }
  }
})
